import { Typography } from '@/components';

export const ErrorMessage = ({ error }: { error?: string }) => {
  if (!error) return null;
  return (
    <Typography as="p" size="body-3" color="error" weight="semibold">
      {error}
    </Typography>
  );
};
